<template>
  <v-layout column>
    <v-flex xs12>
      <h3>Export Account Trips</h3>
    </v-flex>
    <v-layout pt-2 class="search-fields" column>
      <form v-on:keyup.enter="exportTrips">
        <v-autocomplete
          v-model="exportSettings.user"
          :items="customerList"
          :loading="loading"
          :search-input.sync="search"
          item-text="name"
          label="Customer Search*"
          hide-no-data
          hide-selected
          no-filter
          return-object
          @change="customerSelected"
          required
          clearable
          @click:clear="exportSettings.user = {}"
        ></v-autocomplete>
        <v-flex pb-3>
          <BookingDateInput
            @input="fromChanged"
            :content="exportSettings.start_date"
            label="From Date"
          ></BookingDateInput>
        </v-flex>
        <BookingDateInput @input="toChanged" :content="exportSettings.end_date" label="To Date"></BookingDateInput>
        <v-checkbox v-model="exportSettings.account_customers_only" label="Account Customers Only"></v-checkbox>
        <v-checkbox v-model="exportSettings.include_cancelled" label="Include Cancelled"></v-checkbox>
        <v-btn :href="downloadLink" target="_blank" color="blue" dark text class="text-none">Export</v-btn>
        <v-btn
          :href="downloadLinkSage"
          target="_blank"
          color="blue"
          dark
          text
          class="text-none"
        >Export Sage</v-btn>
      </form>
    </v-layout>
  </v-layout>
</template>

<script>
import BookingDateInput from "@/components/widget/input/BookingDateInput.vue";

import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "export_account_trips",
  props: {
    exportSettings: Object
  },
  data: function() {
    var now = new Date();

    return {
      search: null,
      customers: [],
      loading: false
    };
  },
  methods: {
    exportTrips: function() {
      console.log("Export");
    },
    fromChanged: function(d) {
      this.exportSettings.start_date = d;
    },
    toChanged: function(d) {
      this.exportSettings.end_date = d;
    },
    searchCompleted: function(data) {
      this.customers = data.customers;

      this.loading = false;
    },
    customerSelected: function(customer) {
      console.log("Changed " + JSON.stringify(customer));
    }
  },
  components: {
    BookingDateInput
  },
  computed: {
    downloadLinkSage: function() {
      var url = this.downloadLink;

      url += `&format=sage`;

      console.log(url);
      return url;
    },
    downloadLink: function() {
      var url = `${this.$store.state.apiUrl}/customer/exportAccountTrips?start_date=${this.exportSettings.start_date}&end_date=${this.exportSettings.end_date}&include_cancelled=${this.exportSettings.include_cancelled}`;

      if (
        this.exportSettings.user != null &&
        this.exportSettings.user.id != null
      ) {
        url += `&user_id=${this.exportSettings.user.id}`;
      }

      url += `&account_customers_only=${this.exportSettings.account_customers_only}`;

      console.log(url);
      return url;
    },
    customerList: function() {
      return this.customers;
    }
  },
  watch: {
    search(val) {
      if (val == null) return;
      if (val.length <= 1) return;

      var url = `${this.$store.state.apiUrl}/customer/search?query=${val}`;

      var searchCompleted = this.searchCompleted;

      axios({
        url: url,
        method: "GET",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
        .then(function(res) {
          searchCompleted(res.data);
        })
        .catch(function(err) {
          console.error(err);
          this.loading = false;
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.search-fields {
  padding-left: 6px;
  padding-right: 6px;
}
</style>
